// auto-generated by bin/genVersion.ts
export const VERSION = '1.3.5';
//# sourceMappingURL=version.js.map